var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.revoked)?_c('ion-badge',{staticClass:"offline"},[_vm._v(" No ")]):_c('ion-badge',{staticClass:"online"},[_vm._v(" Yes ")])}
var staticRenderFns = []

export { render, staticRenderFns }